/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import DailyProcessListView from '../../view/pages/daily_process/ListView'
import RoomOptionsStore from '../../store/options/RoomOptionsStore'
import fetchUserRooms from '../../action/user/fetchUserRooms'
import DailyClosingHeadsStore from '../../store/daily_closing/DailyClosingHeadsStore'
import DailyProcessListSearchStore from '../../store/daily_closing/DailyProcessListSearchStore'
import DailyProcessListViewStore from '../../store/daily_closing/DailyProcessListViewStore'
import DailyClosingAction from '../../action/daily_closing'
import LocalDate from '../../domain/type/Date'
import _ from 'lodash'
import NProgress from 'nprogress'

class ListContainer extends Component {
  static getStores() {
    return [DailyProcessListViewStore, RoomOptionsStore, DailyClosingHeadsStore, DailyProcessListSearchStore]
  }

  static calculateState(prevState, props) {
    return {
      view: DailyProcessListViewStore.getState(),
      room_options: RoomOptionsStore.getState(),
      heads: DailyClosingHeadsStore.getState(),
      search: DailyProcessListSearchStore.getState(),
      ...props
    }
  }

  async componentDidMount() {
    NProgress.start()
    const date = this.state.match.params.date

    if (date) {
      const room_ids = _.get(this.state, 'location.state.room_ids')
      const state = this.state.search.setValue('search_room_ids', room_ids)
      await DailyClosingAction.fetchDate(new LocalDate(date), state)
    } else {
      await DailyClosingAction.dateChange(this.state.view.date)
    }

    await fetchUserRooms()

    NProgress.done()
  }

  render() {
    return DailyProcessListView(this.state)
  }
}

export default withRouter(Container.create(ListContainer, { withProps: true }))
